module.exports = __webpack_public_path__ + "static/media/quartz-wrist-watch.736a1d6f.jpg";